import React from 'react';
import classes from './ZeroResult.module.css';
import genderAvatarOne from '../../../assets/images/avatar/user-placeholder-gender-one.webp';
import genderAvatarTwo from '../../../assets/images/avatar/user-placeholder-gender-two.webp';
import genderAvatarThree from '../../../assets/images/avatar/user-placeholder-gender-three.webp';
import config from '../../../constants/config';
import Button from '../Button/Button';

const zeroResult = (props) => {
  let avatar = genderAvatarTwo;
  if (props.sex && !props.src) {
    let sexId = parseInt(props.sex, 5);
    if (sexId === config.GENDER_ONE) {
      avatar = genderAvatarOne;
    } else if (sexId === config.GENDER_TWO) {
      avatar = genderAvatarTwo;
    } else {
      avatar = genderAvatarThree;
    }
  }

  let headerTitle = typeof props.headerTitle === 'string' ? <h1 className={classes.Header}>{props.headerTitle}</h1> : props.headerTitle;
  let subTitle = typeof props.subTitle === 'string' ? <p className={classes.SubTitle}>{props.subTitle}</p> : props.subTitle;
  let secondSubTitle = typeof props.secondSubTitle === 'string' ? <p className={classes.SecondSubTitle}>{props.secondSubTitle}</p> : props.secondSubTitle;

  return (
    <div className={classes.ZeroResultWrapper}>
      <div className={classes.ZeroResult}>
        <div className={classes.ZeroResultContent}>
          {headerTitle}
          <img className={classes.Img} src={props.src ? props.src : avatar} alt={props.alt} />
          {subTitle}
          {secondSubTitle}
          {props.buttonText ? <Button clicked={props.buttonClick}>{props.buttonText}</Button> : null}
        </div>
      </div>
    </div>
  );
};

export default zeroResult;
